<script setup lang="ts">
const {t} = useI18n({
  useScope: 'global'
})
</script>

<template>
  <div>
    <div class="car-invoice-v2__notes">
      <p class="text">
        {{ t('pdf.invoice.loan.ensureAmountTransferredInCurrency') }}
      </p>
      <p class="text">
        {{ t('pdf.invoice.loan.ensureReconversionRate') }}
      </p>
    </div>

    <div class="car-invoice-v2__rules">
      <p class="text">
        {{ t('pdf.invoice.loan.ensureVinCodeCorrect') }}
      </p>
      <p class="text">
        {{ t('pdf.invoice.loan.ensureTransferAmountCorrect') }}
      </p>
    </div>

    <div class="car-invoice-v2__warning">
      {{ t('pdf.invoice.loan.ensurePaymentSettledNextDay') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.car-invoice-v2__notes {
  padding: 12px 0;
  border-bottom: 1px solid #000;

  .text {
    font-size: 11px;
    margin-bottom: 10px;
    max-width: 420px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}


.car-invoice-v2__rules {
  padding: 12px 0;

  .text {
    // max-width: 425px;
    font-size: 11px;
  }
}


.car-invoice-v2__warning {
  max-width: 425px;
  font-size: 11px;
}
</style>
